import React, { useState, useEffect, useRef } from "react";
import "./SLists.scss";
import ChooseSongs from "../../components/widgets/ChooseSongs/ChooseSongs";
import ShowSongs from "../../components/widgets/ChooseSongs/ShowSongs";
import debounce from "lodash/debounce";
import {
  IoPencil,
  IoArrowUpCircleSharp,
  IoTrashOutline,
  IoChevronDownOutline,
  IoChevronUpOutline
} from "react-icons/io5";
//import SelectSongBook from "../../components/widgets/UI/SelectSongBook";
import SelectUsers from "../../components/widgets/UI/SelectUsers";
import RestClient from "../../@core/restClient";
//import SongFullScreen from "./../../components/widgets/UI/SongFullScreen";
//import draftToHtml from "draftjs-to-html";
import Spinner from "../../components/widgets/UI/Spinner";
import { Auth } from "../../@core/auth";
import SelectSongBook from "../../components/widgets/UI/SelectSongBook";

const SLists = () => {
  const [userId, setUserId] = useState(
    JSON.parse(localStorage.getItem("User") || "{}")?.id || ""
  );
  const [creatorId, setCreatorId] = useState("");
  const [creator, setCreator] = useState("");
  //const [newGoupId, setNewGroupId] = useState(null);
  const [selections, setSelections] = useState([]);
  const [selectionGroupId, setSelectionGroupId]: any = useState("");
  const [songDates, setSongDates] = useState<any[]>([]);
  // const [selectionGroupId, setSelectionGroupId] = useState(
  //   localStorage.getItem("groupId") || ""
  // );
  const [groupsList, setGroupsList] = useState<any[]>([]);
  const [sListSettings, setsListSettings] = useState("hide-modal");
  const [chooseOption, setChooseOption] = useState("chooseGroup");
  const [optionLabel, setOptionLabel] = useState("Вибрати групу");
  const [openList, setOpenList] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [chooseSongsModal, setChooseSongsModal] = useState(false);
  const [newGroupName, setNewGroupName] = useState("");
  const [collaboratorsList, setCollaboratorsList] = useState<any[]>([]);
  const [showCollaborators, setShowCollaborators] = useState<any[]>([]);
  const [btnSaveDisabled, setBtnSaveDisabled] = useState(true);
  const [isNewGroupSent, setIsNewGroupSent] = useState(true);
  const [isSelectionSent, setIsSelectionSent] = useState(false);
  const [editedSelection, setEditedSelection] = useState({
    id: 0,
    name: "",
    date: "",
    songs: []
  });
  const [isCreate, setIsCreate] = useState(false);
  const [editedId, setEditedId] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [newGroupId, setNewGroupId] = useState(0);
  const [yesDelete, setYesDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [chooseScroll, setChooseScroll] = useState(true);
  const [mainBookId, setMainBookId] = useState(null);
  const [tempMainBookId, setTempMainBookId] = useState(null);
  //const [selectedMainBook, setSelectedMainBook] = useState(null);
  const [mainSongbook, setMainSongbook] = useState<any>({});
  const emptyRef = useRef();
  const refEdit = useRef();
  const titleRef = useRef<HTMLInputElement | null>(null);

  const newGroupNameHandler = () => {
    setNewGroupName(titleRef.current?.value || "");
    titleRef.current?.value !== "" && (mainBookId !== null || tempMainBookId !== null)
      ? setBtnSaveDisabled(false)
      : setBtnSaveDisabled(true);
  };

  useEffect(() => {
    newGroupNameHandler();
  }, [mainBookId, tempMainBookId]);

  useEffect(() => {
    const scroll = JSON.parse(localStorage.getItem("scroll") || "true");
    setChooseScroll(scroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = chooseSongsModal ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [chooseSongsModal]);

  useEffect(() => {
    const groupId = localStorage.getItem("groupId");
    const creator = Number(localStorage.getItem("groupCreator"));
    const stored = localStorage.getItem("groupCollaborators");
    const collaborators: any[] = stored ? JSON.parse(stored) : [];
    if (groupId !== null) {
      if (userId === creator || collaborators?.includes(userId)) {
        setSelectionGroupId(groupId);
        getGroup(groupId);
      } else {
        setSelectionGroupId("");
        setChooseOption("chooseGroup");
        setSelections([]);
      }
    } else {
      return;
    }
  }, []);

  const togleOpen = (e: any) => {
    e.stopPropagation();
    setOpenList(!openList);
  };

  const addCollaborators = function (collaborators: any) {
    setCollaboratorsList(collaborators);
  };

  const savingNewGroup = () => {
    if (!userId) return;
    const newGroup = {
      id: newGroupId,
      groupName: newGroupName,
      creatorId: userId,
      collaborators: collaboratorsList.map((i: any) => i.id),
      mainSongbookId: tempMainBookId
    };
    if (editMode) {
      setNewGroupName("");
      setEditMode(false);
    } else {
      setNewGroupName("");
      setChooseOption("chooseGroup");
      setEditMode(false);
    }
    setBtnSaveDisabled(true);

    if (emptyRef && emptyRef.current)
      (emptyRef.current as any).emptyCollaboratorsArray();
    setsListSettings("hide-modal");
    saveNewGroupHandler(newGroup);
  };

  const saveNewGroupHandler = (enteredItem: any) => {
    setIsLoading(true);
    if (!editMode) {
      (async () => {
        try {
          delete enteredItem.id;
          const result = await RestClient.addSelectionGroup(enteredItem);
          setIsNewGroupSent(true);
          getGroup(result.id);
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      })();
    } else {
      (async () => {
        try {
          const result = await RestClient.editSelectionGroup(enteredItem);
          setIsNewGroupSent(true);
          setEditMode(false);
          getGroup(result.id);
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      })();
    }
  };

  const deleteGroup = (id: any) => {
    try {
      setIsLoading(true);
      (async () => {
        const groupDeleted = await RestClient.deleteSelectionGroup(id);
        if (groupDeleted) {
          setChooseOption("chooseGroup");
          setOptionLabel("Вибрати групу");
          setsListSettings("hide-modal");
          setSelectionGroupId("");
          setBtnDisabled(true);
          setMainSongbook({});
          setMainBookId(null);
          setSelections([]);
          setIsNewGroupSent(true);
          setYesDelete(false);
        }
        localStorage.removeItem("groupId");
        localStorage.removeItem("collaborators");
        localStorage.removeItem("groupCreator");
      })();
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  //Dealing with song Selections

  const saveNewListHandler = (songSelection: any) => {
    if (!isCreate) {
      try {
        (async () => {
          const result = await RestClient.editSelection(
            editedId,
            songSelection
          );
          //getGroup(result.id);
        })();
        setIsSelectionSent(true);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        (async () => {
          const result = await RestClient.addSelection(songSelection);
        })();
        setIsSelectionSent(true);
        setIsCreate(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const deleteSelection = (id: number) => {
    try {
      setIsLoading(true);
      (async () => {
        const result = await RestClient.deleteSelection(id);
        if (result) {
          setSelections(selections.filter((item: any) => item.id !== id));
        }
      })();
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const editSelection = (
    id: number,
    name: string,
    date: any,
    songs: [],
    sort: []
  ) => {
    const edited = {
      id: id,
      name: name,
      date: date,
      songs: songs,
      sort: sort
    };
    setEditedSelection(edited);
    setEditedId(edited.id);

    setChooseSongsModal(true);
  };
  useEffect(() => {
    const dateList = selections.map((item: any) => {
      return { date: item.date, songs: item.songs.map((el: any) => el?.id) };
    });
    setSongDates(dateList);
  }, [selections]);

  useEffect(
    function () {
      if (refEdit && refEdit.current) (refEdit.current as any).edit();
      //setEditedId(editedSelection.id);
    },
    [editedSelection]
  );

  useEffect(() => {
    if (openList) {
      document.body.addEventListener("click", () => {
        setOpenList(false);
      });
    } else {
      return;
    }
  }, [openList]);

  const getGroup = (id: any) => {
    setIsLoading(true);
    (async () => {
      try {
        const group = await RestClient.getSelectionGroup(Number(id));
        if (group) {
          setChooseOption(group.id);
          setSelectionGroupId(group.id);
          setOptionLabel(group.groupName);
          setShowCollaborators(group.collaborators);
          //setSelections(group.selection);
          setCreatorId(group.creatorId);
          setCreator(`${group.creator.firstName} ${group.creator.lastName}`);
          setBtnDisabled(false);
          localStorage.setItem("groupId", group.id);
          localStorage.setItem("groupCreator", group.creatorId);
          const collabs = group.collaborators.map((person: any) => person.id);
          localStorage.setItem("groupCollaborators", JSON.stringify(collabs));
          setMainBookId(group.mainSongbookId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    })();
  };

  useEffect(() => {
    (async () => {
      if (mainBookId !== null) {
        const book = await RestClient.getSongbook(mainBookId);
        if (book) {
          setMainSongbook(book);
        }
      } else {
        setMainSongbook({});
      }
    })();
  }, [mainBookId]);

  const chooseGroupHandler = (item: any, e: any) => {
    e.stopPropagation();
    setOpenList(false);
    setChooseOption(item.id);
    setSelectionGroupId(item.id);
    setOptionLabel(item.groupName);
    setCollaboratorsList(item.collaborators);
    setShowCollaborators(item.collaborators);
    setCreatorId(item.creatorId);
    setMainBookId(item.mainSongbookId);
    localStorage.setItem("groupId", item.id);
    localStorage.setItem("groupCreator", item.creatorId);
    const collabs = item.collaborators.map((person: any) => person.id);
    localStorage.setItem("groupCollaborators", JSON.stringify(collabs));

    if (item.id === "create") {
      setsListSettings("");
      setBtnDisabled(true);
      setOptionLabel(item.groupName);
      setSelections([]);
      setMainBookId(null);
      setMainSongbook({});
      return;
    }

    if (item.id === "chooseGroup") {
      setsListSettings("hide-modal");
      setBtnDisabled(true);
      setMainBookId(null);
      setMainSongbook({});
      return;
    }

    if (item.id !== "create" && item.id !== "chooseGroup")
      setBtnDisabled(false);
    setsListSettings("hide-modal");
    setCreator(`${item.creator.firstName} ${item.creator.lastName}`);

    return;
  };

  const editGroup = (id: any) => {
    try {
      (async () => {
        setIsLoading(true);
        const group = await RestClient.getSelectionGroup(id);
        if (group) {
          setNewGroupName(group.groupName);
          setCollaboratorsList(group.collaborators);
          setShowCollaborators(group.collaborators);
          setCreatorId(group.creatorId);
          setCreator(`${group.creator.firstName} ${group.creator.lastName}`);
          setEditMode(true);
          setsListSettings("");
          setBtnSaveDisabled(false);
          setNewGroupId(group.id);
          const collabs = group.collaborators.map((person: any) => person.id);
          localStorage.setItem("groupCollaborators", JSON.stringify(collabs));
        }
        setIsLoading(false);
      })();
    } catch (error) {
      console.log(error);
    }
  };

  const hideSettingsHandler = () => {
    setOpenList(false);
    if (editMode) {
      setsListSettings("hide-modal");
      setIsCreate(false);
      setEditMode(false);
      setBtnSaveDisabled(true);
      setNewGroupName("");
    } else {
      setsListSettings("hide-modal");
      setChooseOption("chooseGroup");
      setOptionLabel("Вибрати групу");
      setBtnDisabled(true);
      setNewGroupName("");
      setBtnSaveDisabled(true);
      setIsCreate(false);
      setEditMode(false);
      setSelections([]);
    }

    if (emptyRef && emptyRef.current)
      (emptyRef.current as any).emptyCollaboratorsArray();
  };

  const displayChooseSongsModal = () => {
    setChooseSongsModal(true);
    setIsCreate(true);
  };
  const hideChooseSongsModal = () => {
    setChooseSongsModal(false);
    setIsCreate(false);
  };

  const inactiveBtn = {
    background: "#999",
    transform: "scale(1)"
  };
  const inactiveOnhover = {
    boxSshadow: "none",
    transform: "none"
  };

  // GET SELECTIONS
  useEffect(
    function () {
      // if (!isSelectionSent) {
      //   console.log("I returned");
      //   return;
      // }
      (async () => {
        if (
          selectionGroupId === "" ||
          selectionGroupId === "create" ||
          selectionGroupId === "chooseGroup"
        ) {
          return;
        } else {
          try {
            setIsLoading(true);
            const list: any = await RestClient.getSelections(selectionGroupId);
            const newList = list?.map((selection: any) => {
              const order: any = [];
              selection.sort.forEach((songNumber: any) => {
                const song = selection.songs.find(
                  (song: any) => song.id === songNumber
                );
                if (song) {
                  order.push(song);
                }
              });
              return { ...selection, songs: order };
            });
            if (
              selectionGroupId === "" ||
              selectionGroupId === "create" ||
              selectionGroupId === "chooseGroup"
            ) {
              return;
            } else {
              setSelections(newList || []);
            }

            setIsSelectionSent(false);
          } catch (error) {
            console.log(error);
          }
          setIsLoading(false);
        }
      })();
    },
    [selectionGroupId, isSelectionSent]
  );

  useEffect(
    function () {
      setIsLoading(true);
      if (isNewGroupSent) {
        try {
          (async () => {
            const groupsList: any = await RestClient.getSelectionGroups(userId);
            const groupsListCollab: any =
              await RestClient.getSelectionGroupsCollab(userId);
            const list = [...groupsList, ...groupsListCollab];
            setGroupsList(list || []);
            setIsNewGroupSent(false);
            return groupsList;
          })();
        } catch (error) {
          console.log(error);
        }
      }
      setIsLoading(false);
      setIsNewGroupSent(false);
    },
    [isNewGroupSent]
  );

  const updateSelectionSongKeys = (selectionId: number, songKeys: any) => {
    setSelections((prev: any) =>
      prev.map((sel: any) => sel.id === selectionId ? { ...sel, songKeys } : sel)
    );
  };

  const sure = () => {
    setYesDelete(true);
  };
  const cansel = () => {
    setYesDelete(false);
  };

  // SWITCH SCROLL
  const switchScroll = () => {
    if (chooseScroll) {
      setChooseScroll(false);
      localStorage.setItem("scroll", JSON.stringify(false));
    } else {
      setChooseScroll(true);
      localStorage.setItem("scroll", JSON.stringify(true));
    }
  };

  // SETTING MAIN SONGBOOK
  const getBookId = (bookId: any) => {
    setTempMainBookId(bookId);
    // setIsValidSong(true);
  };

  return (
    <div className="slist">
      {isLoading ? <Spinner /> : ""}
      <div className="group-big-box">
        <div className="group-box">
          <p className="slist-setting-btn">Група: </p>
          <div onClick={(e) => togleOpen(e)} className="group-box-input">
            <input
              readOnly
              //onChange={chooseGroupHandler}
              className="slist-choose-group"
              value={optionLabel}
            />
            {openList ? (
              <IoChevronUpOutline className="group-box-icon" />
            ) : (
              <IoChevronDownOutline className="group-box-icon" />
            )}
          </div>
          {openList ? (
            <div className="group-box-list">
              <p
                className="group-box-list-first"
                onClick={(e) =>
                  chooseGroupHandler(
                    {
                      id: "create",
                      groupName: "Створити групу",
                      collaborators: [],
                      creatorId: null
                    },
                    e
                  )
                }
              >
                Створити групу
              </p>
              {groupsList.map((item) => (
                <p onClick={(e) => chooseGroupHandler(item, e)} key={item.id}>
                  {item.groupName}
                </p>
              ))}
            </div>
          ) : (
            ""
          )}
        </div>
        {chooseOption === "create" ||
        chooseOption === "chooseGroup" ||
        Number(userId) !== Number(creatorId) ? null : (
          <div className="group-btns">
            <div className="my-tooltip">
              <button
                className=" group-btns-btn"
                onClick={() => editGroup(chooseOption)}
              >
                <IoPencil />
              </button>
              <span className="my-tooltip-text tooltip-bottom-left">
                Редагувати групу
              </span>
            </div>
            <div className="my-tooltip">
              <button className=" group-btns-btn" onClick={sure}>
                <IoTrashOutline />
              </button>
              <span className="my-tooltip-text tooltip-bottom-left">
                Видалити групу
              </span>
            </div>
          </div>
        )}
      </div>
      {chooseOption !== "create" && chooseOption !== "chooseGroup" ? (
        <div className="info-box">
          {" "}
          <p className="creator">Власник: {creator}</p>
          <p className="creator">Основний збірник: {mainSongbook.title}</p>
          <div className="collaborators">
            <p>Учасники:</p>
            {showCollaborators?.map((item) => (
              <p key={item.id} className="collaborators-each">
                {item.firstName} {item.lastName};
              </p>
            ))}
          </div>
        </div>
      ) : (
        ""
      )}
      {/*  create || edit selection gorup */}
      <div className={sListSettings || "create-selection-modal"}>
        <div className="settings-box">
          <h2 className="settings-box-title">
            {editMode ? "Редагувати групу" : "Створити групу"}
          </h2>
          <p className="attributes-usrs">Виберіть основний збірник</p>
          <SelectSongBook passBookId={getBookId} mainSongbook={mainSongbook} isOpen={sListSettings !== "hide-modal"} />

          <p className="attributes-users">Введіть назву групи</p>
          <input
            type="text"
            className="create-group-title"
            value={newGroupName}
            onChange={newGroupNameHandler}
            ref={titleRef}
          />

          <p className="attributes-users">Виберіть учасників</p>
          <div className="select-users">
            {/* {Auth.isSinglePaid ? (
              <div className="select-users-disabled">
                <p className="select-users-disabled-text">
                  Щоб додавати учасників, будь ласка, перейдіть на більш
                  розширений тарифний план.
                </p>
              </div>
            ) : (
              ""
            )} */}
            <SelectUsers
              passingCollaboratorsArray={addCollaborators}
              ref={emptyRef}
              collaboratorsList={collaboratorsList}
              editMode={editMode}
            />
          </div>

          <div className="choose-btns" style={{ position: "relative", zIndex: 20 }}>
            <button
              className={`${
                btnSaveDisabled ? "btn-mcolor-inactive" : "btn-mcolor"
              }`}
              disabled={btnSaveDisabled}
              onClick={savingNewGroup}
            >
              Зберегти
            </button>
            <button className="btn-plain" onClick={hideSettingsHandler}>
              Скасувати
            </button>
          </div>
        </div>
      </div>
      <button
        className={`${
          btnDisabled
            ? "btn-mcolor-inactive slists-btn-create mrg-top"
            : "btn-mcolor slists-btn-create"
        }`}
        disabled={btnDisabled}
        onClick={displayChooseSongsModal}
      >
        Створити підбірку
      </button>
      {/* crete and adit modal for song selections */}
      {chooseSongsModal ? (
        <div className="create-selection-modal">
          <ChooseSongs
            title={isCreate ? "Створити підбірку" : "Редагувати підбірку"}
            //groupId={Number(chooseOption: any)}
            onSavingSongList={saveNewListHandler}
            hideChooseSongsModal={hideChooseSongsModal}
            selectionGroupId={selectionGroupId}
            editedSelection={editedSelection}
            songDates={songDates}
            ref={refEdit}
            mainSongbook={mainSongbook}
          />
        </div>
      ) : (
        ""
      )}
      <div className="switch-box">
        <p>Кнопки горизонтальної навігації </p>

        <div
          className={`switch ${chooseScroll ? "on" : ""}`}
          onClick={switchScroll}
        >
          <div className="slider"></div>
        </div>
        <p> {chooseScroll ? "On" : "Off"}</p>
      </div>
      <div className="show-songs-margin">
        {[...selections]
          .sort(
            (a: any, b: any) =>
              new Date(b.date).getTime() - new Date(a.date).getTime()
          )
          .map((item: any) => (
            <div key={item.id}>
              <ShowSongs
                id={item.id}
                name={item.name}
                date={item.date}
                songs={item.songs}
                songKeys={item.songKeys}
                onDelete={deleteSelection}
                editSelection={editSelection}
                scroll={chooseScroll}
                isOwner={Number(userId) === Number(creatorId)}
                onKeysUpdate={updateSelectionSongKeys}
              />
            </div>
          ))}
        {/* <SongFullScreen selectedSongs={selections[0]} /> */}
      </div>
      {yesDelete ? (
        <div className="delete">
          <div className="delete-box">
            <p className="delete-box-message">
              Bидалити групу{" "}
              <span className="group-to-delete"> {optionLabel}</span> ?
            </p>
            <div className="delete-box-btns">
              <button
                className="btn-mcolor delete-box-btn "
                onClick={() => deleteGroup(chooseOption)}
              >
                Так
              </button>{" "}
              <button className="btn-plain delete-box-btn " onClick={cansel}>
                Ні
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SLists;
